// extracted by css-extract-rspack-plugin
export default {"cls1":"CiterightLanding-cls1_H8e","cls2":"CiterightLanding-cls2_SWs CiterightLanding-cls1_H8e"};